/**
 * Vuex 根 store
 * 功能：聚合 menuList/headerTabs/themePicker/getData 四个模块
 */
import Vue from 'vue'
import Vuex from 'vuex'
import headerTabs from './module/headerTabs'
import menuList from './module/menuList'
import themePicker from './module/themePicker'
import getData from './module/getData'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: { // 模块引用
    menuList,
    headerTabs,
    themePicker,
    getData
  }
})